export default __webpack_public_path__ + "static/media/4.756f38f2.svg";